import { SVGIconProps } from './types'

export const UnionBlockIcon = (props: SVGIconProps) => {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 2.5C2.22386 2.5 2 2.72386 2 3V5C2 5.27614 2.22386 5.5 2.5 5.5H12.5C12.7761 5.5 13 5.27614 13 5V3C13 2.72386 12.7761 2.5 12.5 2.5H2.5ZM1 3C1 2.17157 1.67157 1.5 2.5 1.5H12.5C13.3284 1.5 14 2.17157 14 3V5C14 5.82843 13.3284 6.5 12.5 6.5H2.5C1.67157 6.5 1 5.82843 1 5V3Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 10.5C2.22386 10.5 2 10.7239 2 11V13C2 13.2761 2.22386 13.5 2.5 13.5H12.5C12.7761 13.5 13 13.2761 13 13V11C13 10.7239 12.7761 10.5 12.5 10.5H2.5ZM1 11C1 10.1716 1.67157 9.5 2.5 9.5H12.5C13.3284 9.5 14 10.1716 14 11V13C14 13.8284 13.3284 14.5 12.5 14.5H2.5C1.67157 14.5 1 13.8284 1 13V11Z"
        fill="currentColor"
      />
      <path
        d="M7.5 9.5L7.5 6.13623"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  )
}
